import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {SessionContext} from "../models/session-context.model";
import {UserInfo} from "../models/user-info.model";
import {PatientRole} from "../models/patient-role.model";

export enum personSex {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

@Injectable({
  providedIn: "root",
})
export class UserInfoService {
  storagedSessionContext = this.getSessionContext();
  storedUserInfo = this.getUserInfo();
  userInfo = new BehaviorSubject<UserInfo>(this.storedUserInfo);
  sessionContext = new BehaviorSubject<SessionContext>(this.storagedSessionContext);
  sessionContext$ = this.sessionContext.asObservable();

  get personId() {
    return this.getSessionContext().principal.id;
  }

  getUserInfo(): UserInfo {
    return JSON.parse(sessionStorage.getItem("userInfo"));
  }

  getSessionContext(): SessionContext {
    return JSON.parse(sessionStorage.getItem("sessionContext"));
  }

  getSessionIdWhenNotLoggedIn(): string {
    return sessionStorage.getItem("sessionId");
  }

  setSessionContext(newContext: SessionContext) {
    if (newContext) {
      sessionStorage.setItem("sessionContext", JSON.stringify(newContext));
    }
    this.sessionContext.next(newContext);
  }

  getIsExternalPatient(): boolean {
    const sessionContext = this.getSessionContext();
    return sessionContext ? sessionContext.patientRole === PatientRole.EXTERNAL : false;
  }

  getPersonAgeFromPersonCode(personCode: string): number {
    const centuryCode = parseInt(personCode.charAt(0), 10);
    const year = parseInt(personCode.substring(1, 3), 10);
    const month = parseInt(personCode.substring(3, 5), 10);
    const day = parseInt(personCode.substring(5, 7), 10);

    let fullYear: number;
    switch (centuryCode) {
      case 3:
      case 4:
        fullYear = 1900 + year;
        break;
      case 5:
      case 6:
        fullYear = 2000 + year;
        break;
      default:
        return null;
    }

    const birthDate = new Date(fullYear, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  getPersonSexFromPersonCode(personCode: string): string {
    const firstDigit = parseInt(personCode.charAt(0), 10);
    return firstDigit % 2 === 0 ? personSex.FEMALE : personSex.MALE;
  }

  isFemaleOfChildbearingAge(sex: personSex, age: number): boolean {
    return sex === personSex.FEMALE && age >= 15 && age <= 49;
  }
}
